module.exports = __webpack_public_path__ + "static/media/bg-login.5cee1ed8.png";